import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
export function Footer() {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalType, setModalType] = useState<'privacy' | 'terms'>('privacy');
  const openModal = (type: 'privacy' | 'terms') => {
    setModalType(type);
    setModalOpen(true);
  };
  return <>
      <footer className="bg-warm-brown text-white py-8 md:py-12 px-4" data-id="element-43">
        <div className="max-w-4xl mx-auto" data-id="element-44">
          {/* Main Footer Content */}
          <div className="text-center mb-6" data-id="element-45">
            <h3 className="font-heading text-xl md:text-2xl mb-3" data-id="element-46">
              🌿 Sinergia Ancestral
            </h3>
            <p className="text-sm md:text-base text-gray-300 mb-4" data-id="element-47">
              El Código Maestro de la Salud Natural
            </p>
          </div>

          {/* Legal Links */}
          <div className="flex flex-wrap items-center justify-center gap-3 md:gap-6 mb-6 text-sm md:text-base" data-id="element-48">
            <button onClick={() => openModal('privacy')} className="text-white hover:text-sage-light underline transition-colors" data-id="element-49">
              Política de Privacidad
            </button>
            <span className="text-gray-400" data-id="element-50">•</span>
            <button onClick={() => openModal('terms')} className="text-white hover:text-sage-light underline transition-colors" data-id="element-51">
              Términos y Condiciones
            </button>
          </div>

          {/* Copyright */}
          <div className="text-center border-t border-white/20 pt-6" data-id="element-52">
            <p className="text-sm mb-4" data-id="element-53">
              © 2025 Sinergia Ancestral. Todos los derechos reservados.
            </p>
            <p className="text-xs text-gray-300 max-w-3xl mx-auto leading-relaxed" data-id="element-54">
              Este producto es de carácter educativo e informativo. No está
              destinado a diagnosticar, tratar, curar ni prevenir ninguna
              enfermedad. Consulta siempre a tu profesional de salud antes de
              iniciar cualquier protocolo natural, especialmente si tomas
              medicamentos recetados.
            </p>
          </div>
        </div>
      </footer>

      {/* Legal Modal */}
      <LegalModal isOpen={modalOpen} onClose={() => setModalOpen(false)} type={modalType} data-id="element-55" />
    </>;
}